export default {
  ulStyles:{
    color:"#fff",
    listStyle:"none",
    float:"right",
    position:"relative",
    padding:0,
    margin:0,
    textTransform:"uppercase",
    fontWeight: "500",
  },
  threeBCStyles:{
    maxWidth:"1200px",
    width:"100%",
    margin:"0 auto",
    zIndex:"1000",
  },
  liStyles:{
    display: "inline",
    float: "left",
    background: "rgb(0, 113, 85)",
    margin:0,
  },
  buttonStyles: {
    margin: 0,
    width: "auto",
    overflow: "visible",
    color: "inherit",
    fontWeight: "inherit",
    textTransform: "inherit",
    fontFamily: "Roboto, san-serif",
    height: "60px",
    background:"rgb(0, 113, 85)",
    fontSize: "13px",
    padding: "0 20px 1px",
    border: "solid rgb(167, 210, 51)",
    borderWidth: "0 1px",
    cursor: "pointer",
  },
    aStyles:{
      textDecoration: "none",
      border: "none",
      height: "60px",
      display: "block",
      background: "rgb(0, 113, 85)",
      lineHeight: "60px",
      fontFamily: "Roboto, san-serif",
      textAlign: "center",
      padding: "0 20px",
      fontSize: "13px",
  },
    modal:{
      position: "fixed",
      top:"-1500px",
      right: "0",
      bottom: "0",
      left: "0",
      background: "#fff",
      zIndex: "99990",
      opacity: "0",
      WebkitTransition: "opacity 400ms ease-in",
      MozTransition: "opacity 400ms ease-in",
      transition: "opacity 400ms ease-in",
      pointerEvents: "none"
    }, 
}